var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimesheetActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1631_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0375 1.59375H10.7625C10.9069 1.59375 11.025 1.71328 11.025 1.85938V3.1875H5.775V1.85938C5.775 1.71328 5.89312 1.59375 6.0375 1.59375ZM4.2 1.85938V3.1875H2.1C0.941719 3.1875 0 4.14043 0 5.3125V8.5H6.3H11.55H11.8191C12.8789 7.20176 14.4802 6.375 16.275 6.375C16.4522 6.375 16.6261 6.38164 16.8 6.39824V5.3125C16.8 4.14043 15.8583 3.1875 14.7 3.1875H12.6V1.85938C12.6 0.833398 11.7764 0 10.7625 0H6.0375C5.02359 0 4.2 0.833398 4.2 1.85938ZM10.5 11.6875H7.35C6.76922 11.6875 6.3 11.2127 6.3 10.625V9.5625H0V13.8125C0 14.9846 0.941719 15.9375 2.1 15.9375H11.8191C10.9955 14.9281 10.5 13.6299 10.5 12.2188C10.5 12.0395 10.5066 11.8635 10.523 11.6875H10.5ZM21 12.2188C21 10.9507 20.5022 9.73455 19.6161 8.8379C18.73 7.94124 17.5281 7.4375 16.275 7.4375C15.0219 7.4375 13.82 7.94124 12.9339 8.8379C12.0478 9.73455 11.55 10.9507 11.55 12.2188C11.55 13.4868 12.0478 14.7029 12.9339 15.5996C13.82 16.4963 15.0219 17 16.275 17C17.5281 17 18.73 16.4963 19.6161 15.5996C20.5022 14.7029 21 13.4868 21 12.2188ZM16.275 9.5625C16.5637 9.5625 16.8 9.80156 16.8 10.0938V11.6875H17.85C18.1388 11.6875 18.375 11.9266 18.375 12.2188C18.375 12.5109 18.1388 12.75 17.85 12.75H16.275C15.9862 12.75 15.75 12.5109 15.75 12.2188V10.0938C15.75 9.80156 15.9862 9.5625 16.275 9.5625Z",
    fill: "#2563eb"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1631_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheetActive);
export default __webpack_public_path__ + "static/media/timesheet-active.467397b21c005b5f76cc73689bdb0b02.svg";
export { ForwardRef as ReactComponent };